function TableContent({ children }) {
  return (
    <div className="table-content table-cell">
      <p className="para">{children}</p>
    </div>
  );
}

export default TableContent;
